export const isMobile = () => {
  return window.matchMedia('(max-width: 767px)').matches;
};
export const isDesktop = () => {
  const width = getComputedStyle(document.documentElement).getPropertyValue('--screen-lg');
  return window.matchMedia(`(min-width: ${width})`).matches;
};
export const isDesktopXl = () => {
  const width = getComputedStyle(document.documentElement).getPropertyValue('--screen-xl');
  return window.matchMedia(`(min-width: ${width})`).matches;
};

export const getViewPortWidth = () => {
  return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
};

export const getViewPortHeight = () => {
  return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
};

export const isAtBottom = () => {
  return window.innerHeight + window.scrollY >= document.body.offsetHeight;
};

export default {
  isDesktopMenuVisible: true,
};
